"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var funcParams_1 = require("./funcParams");
var fix_parent_1 = require("./fix$parent");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
/**
 * tworzy funkcję agregującą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
function aggregateFunction(schema, cache, debug, useStrict) {
    var _a, _b, _c, _d;
    if (cache === void 0) { cache = true; }
    if (schema.aggregate) {
        if (schema._aggregateFunc) {
            return schema._aggregateFunc;
        }
        var aggregateFunc = null;
        var func = schema.aggregate.func || 'sum';
        var ifprop = schema.aggregate.when || schema.aggregate.if;
        var cachekey = '';
        if (cache && !debug) {
            cachekey =
                "agg||" + func
                    + ("||array:" + schema.aggregate.array)
                    + ("||prop:" + schema.aggregate.property)
                    + (ifprop ? '||when:' + ifprop : '')
                    + ('||type:' + schema.type)
                    + (schema.precision ? '||prec:' + schema.precision : '');
            aggregateFunc = cacheFuncs[cachekey];
            if (aggregateFunc) {
                Object.defineProperty(schema, '_aggregateFunc', {
                    value: aggregateFunc
                });
                return aggregateFunc;
            }
        }
        // let aggregateFunc = cache ? schema.cache.aggregateFunc : null;
        // może być podanna jako tablica
        var arraylist = schema.aggregate.array;
        if (!Array.isArray(arraylist)) {
            arraylist = [arraylist];
        }
        var need$item = false;
        if (ifprop) {
            // ifprop = fix$parent(ifprop).replace(/\$item/g, '$array[$index]');
            ifprop = fix_parent_1.default(ifprop);
            need$item = true;
        }
        var prop = schema.aggregate.property;
        var $item = '';
        if (prop) {
            var complexprop = /[\$\.]/.test(prop);
            if (!complexprop) {
                prop = '$array[$index].' + prop;
            }
            else {
                need$item = true;
                // prop = fix$parent(prop).replace(/\$item/g, '$array[$index]');
                prop = fix_parent_1.default(prop);
            }
        }
        else {
            if (schema.type === 'array' && ((_a = schema.items) === null || _a === void 0 ? void 0 : _a.type) === 'object') {
                need$item = false;
                var keys = Object.keys(((_b = schema.items) === null || _b === void 0 ? void 0 : _b.properties) || {});
                $item += '\n  var $item = $array[$index]; $item = {' + keys.map(function (x) { var _a, _b; return ((((_a = schema.items) === null || _a === void 0 ? void 0 : _a.properties) || {})[x].type === 'array' || (((_b = schema.items) === null || _b === void 0 ? void 0 : _b.properties) || {})[x].type === 'object') ? x + ': $item.' + x + '===undefined ? undefined : $methods.deepCopy($item.' + x + ')' : x + ': $item.' + x; }).join(', ') + '}';
                prop = '$item';
            }
            else {
                prop = '$array[$index]';
            }
        }
        if (need$item) {
            $item += '\n  var $item = $array[$index];';
        }
        var ftext = 'var $length = 0;\n';
        // ftext += `var sttime=(new Date()).getTime();var $length=0;`;
        switch (func) {
            case 'mul':
                ftext += "var $result = 1;\n";
                break;
            case 'min':
                if (schema.type === 'string') {
                    ftext += "var $result = '\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A';\n";
                }
                else {
                    ftext += "var $result = Infinity;\n";
                }
                break;
            case 'max':
                if (schema.type === 'string') {
                    ftext += "var $result = '';\n";
                }
                else {
                    ftext += 'var $result = -Infinity;\n';
                }
                break;
            case 'map':
            case 'distinct':
                ftext += "var $result = [];\n";
                break;
            case 'distinctitem':
                ftext += "var $result = [];\n";
                ftext += "var $distinct = {};\n";
                break;
            default:
                switch (schema.type) {
                    case 'string':
                        ftext += "var $result='';\n";
                        break;
                    case 'object':
                        ftext += "var $result=null;\n";
                        break;
                    default:
                        ftext += "var $result = 0;\n";
                }
                break;
        }
        var ltext = '';
        // ltext += `// func: ${func}\n`;
        switch (func) {
            case 'avg':
            case 'sum':
                ltext += "$result += (" + prop + "); // func: " + func;
                break;
            case 'max':
                ltext += "var $v = (" + prop + "); // func: " + func + "\n";
                ltext += "  if ($v > $result)\n";
                ltext += "    $result=$v";
                break;
            case 'min':
                ltext += "var $v = (" + prop + "); // func: " + func + "\n";
                ltext += "  if ($v < $result)\n";
                ltext += "    $result=$v";
                break;
            case 'mul':
                ltext += "$result *= (" + prop + "); // func: " + func;
                break;
            case 'count':
                ltext += "$result++; // func: " + func;
                break;
            case 'first':
            case 'last':
                ltext += "$result = (" + prop + ");break; // func: " + func;
                break;
            case 'map':
                ltext += "$result.push(" + prop + "); // func: " + func;
                break;
            case 'distinct':
                ltext += "var $v = (" + prop + "); // func: " + func + "\n";
                ltext += "  if ($result.indexOf($v)===-1)\n";
                ltext += "    $result.push($v)";
                break;
            case 'distinctitem':
                var what = '$array[$index]';
                if (schema.type === 'array' && ((_c = schema.items) === null || _c === void 0 ? void 0 : _c.type) === 'object') {
                    var keys = Object.keys(((_d = schema.items) === null || _d === void 0 ? void 0 : _d.properties) || {});
                    // what = '{' + keys.map(x => x + ': $array[$index].' + x).join(', ') + '}';
                    what = '{' + keys.map(function (x) { var _a, _b; return ((((_a = schema.items) === null || _a === void 0 ? void 0 : _a.properties) || {})[x].type === 'array' || (((_b = schema.items) === null || _b === void 0 ? void 0 : _b.properties) || {})[x].type === 'object') ? x + ': $array[$index].' + x + '===undefined ? undefined : $methods.deepCopy($array[$index].' + x + ')' : x + ': $array[$index].' + x; }).join(', ') + '}';
                }
                ltext += "var $v = (" + prop + "); // func: " + func + "\n";
                ltext += "  if ($distinct[$v]===undefined) {\n";
                ltext += "    $result.push(" + what + ");\n";
                ltext += "    $distinct[$v] = $index;\n";
                ltext += "  }";
                break;
        }
        if (ifprop) {
            if (func === 'first' || func === 'map' || func === 'distinct' || func === 'distinctitem') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength = $array.length;\nfor(var $index = 0; $index < $arrayLength; $index++) {" + $item + "\n  if (" + ifprop + ") { // if: " + (schema
                    .aggregate.when || schema.aggregate.if) + "\n    $length++;\n    " + ltext + "\n  }\n}";
            }
            else {
                ltext =
                    "var $index = $array.length;\n" +
                        ("while($index--) {" + $item + "\n  if (" + ifprop + ") { // if: " + (schema.aggregate.when ||
                            schema.aggregate.if) + "\n    $length++;\n    " + ltext + "\n  }\n}");
            }
            // ftext += `do {with(aaa[i]) {if (${ifprop}) {${ltext}}}} while(i--);`;
        }
        else {
            if (func === 'first' || func === 'map' || func === 'distinct' || func === 'distinctitem') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength = $array.length;\n$length += $arrayLength;\nfor(var $index = 0; $index < $arrayLength; $index++) {" + $item + "\n  " + ltext + "\n}";
            }
            else {
                ltext = "var $index = $array.length;\n$length += $index;\nwhile($index--) {" + $item + "\n  " + ltext + "\n}";
            }
        }
        for (var _i = 0, arraylist_1 = arraylist; _i < arraylist_1.length; _i++) {
            var arraykey = arraylist_1[_i];
            var subarray = null;
            var pp = arraykey.indexOf('/');
            if (pp > -1) {
                subarray = arraykey.substr(pp + 1);
                arraykey = arraykey.substr(0, pp);
            }
            var complexarray = /[\$\.]/.test(arraykey);
            if (!complexarray) {
                arraykey = 'this.' + arraykey;
            }
            arraykey = fix_parent_1.default(arraykey);
            if (subarray) {
                if (debug) {
                    ftext += "\n/*** " + arraykey + "/" + subarray + " ***/";
                }
                // tslint:disable-next-line: max-line-length
                ftext += "\nvar $parentArray = " + arraykey + "; // array: " + schema.aggregate.array + "\nvar $parentLength = $parentArray.length;\nfor(var $parentIndex=0; $parentIndex<$parentLength; $parentIndex++) {\n  var $array=$parentArray[$parentIndex]." + subarray + ";\n  if ($array) {\n    " + ltext + "\n}\n}";
            }
            else {
                if (debug) {
                    ftext += "\n/*** " + arraykey + " ***/";
                }
                ftext += "\nvar $array = " + arraykey + ";\n";
                /*
                        switch (func) {
                          case 'min':
                          case 'max':
                          case 'mul': ftext+="if ($result===undefined && $array.length) "
                        }
                        */
                ftext += ltext + '\n';
                // ltext;
            }
        }
        if (func === 'avg') {
            ftext += '\nif ($length)\n  $result /= $length;';
        }
        switch (func) {
            case 'mul':
                ftext += "\nif ($length===0)\n  $result=0;";
                break;
            case 'min':
            case 'max':
                if (schema.type === 'string') {
                    ftext += "\nif ($length === 0)\n  $result = '';";
                }
                else {
                    ftext += "\nif ($length === 0)\n  $result = 0;";
                }
                break;
        }
        if (debug) {
            switch (schema.type) {
                case 'integer':
                    ftext += '\n$result = $methods.mround($result,0);';
                    break;
                case 'money':
                    if (schema.precision) {
                        ftext += "\n$result = $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        ftext += '\n$result = $methods.mround($result,2);';
                    }
                    break;
                case 'number':
                    if (schema.precision) {
                        ftext += "\n$result = $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        // ftext += `\n$result = $result;`;
                    }
                    break;
                case 'object':
                    // deep copy, żeby reagował na kazdą zmianę pola
                    // ftext += `\n$result = $methods.deepCopy($result);`;
                    var keys = Object.keys(schema.properties || {});
                    ftext += '\n$result = !$result ? null : {' + keys.map(function (x) { return ((schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object') ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')' : x + ': $result.' + x; }).join(', ') + '}';
                    break;
                default:
                    // ftext += `\n$result = $result;`;
                    break;
            }
            ftext += "\nreturn $result;";
            // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
            ftext = "\n/*** " + schemaPath_1.default(schema, true) + " aggreagate debug ***/\nconsole.debug($obj.$path); // model path\ndebugger;\n\n/*** function body ***/\n" + ftext;
            // ftext = 'console.debug($obj.$path);\ndebugger;\n' + ftext;
        }
        else {
            switch (schema.type) {
                case 'integer':
                    ftext += '\nreturn $methods.mround($result,0);';
                    break;
                case 'money':
                    if (schema.precision) {
                        ftext += "\nreturn $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        ftext += '\nreturn $methods.mround($result,2);';
                    }
                    break;
                case 'number':
                    if (schema.precision) {
                        ftext += "\nreturn $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        ftext += "\nreturn $result;";
                    }
                    break;
                case 'object':
                    // deep copy, żeby reagował na kazdą zmianę pola
                    // ftext += `\nreturn $methods.deepCopy($result);`;
                    var keys = Object.keys(schema.properties || {});
                    ftext += '\nreturn !$result ? null : {' + keys.map(function (x) { return ((schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object') ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')' : x + ': $result.' + x; }).join(', ') + '}';
                    break;
                default:
                    ftext += "\nreturn $result;";
                    break;
            }
        }
        if (useStrict || process.env.NODE_ENV !== 'production') {
            ftext = "\"use strict\";\n" + ftext;
        }
        aggregateFunc = new Function(funcParams_1.default, ftext);
        if (cachekey) {
            Object.defineProperty(schema, '_aggregateFunc', {
                value: aggregateFunc
            });
            cacheFuncs[cachekey] = aggregateFunc;
        }
        return aggregateFunc;
        // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
    }
}
exports.default = aggregateFunction;
//# sourceMappingURL=aggregateFunction.js.map